export var Role;
(function (Role) {
    /**
     * @deprecated use Manager instead
     */
    Role["Admin"] = "admin";
    Role["Manager"] = "manager";
    Role["Author"] = "author";
    Role["Viewer"] = "viewer";
    /**
     * @deprecated use AuthorRedactedAll instead
     */
    Role["AuthorRedacted"] = "author-redact-on";
    /**
     * @deprecated use ViewerRedactedAll instead
     */
    Role["ViewerRedacted"] = "viewer-redact-on";
    Role["AuthorRedactedSensitive"] = "author-redact-sensitive";
    Role["ViewerRedactedSensitive"] = "viewer-redact-sensitive";
    Role["AuthorRedactedAll"] = "author-redact-all";
    Role["ViewerRedactedAll"] = "viewer-redact-all";
})(Role || (Role = {}));
export const ALL_ROLES = Object.values(Role);
export function roleLabel(role) {
    switch (role) {
        case Role.Admin:
            return 'Account admin';
        case Role.Manager:
            return 'Workspace admin';
        case Role.Author:
        case Role.AuthorRedacted:
        case Role.AuthorRedactedSensitive:
        case Role.AuthorRedactedAll:
            return 'Author';
        case Role.Viewer:
        case Role.ViewerRedacted:
        case Role.ViewerRedactedSensitive:
        case Role.ViewerRedactedAll:
            return 'Viewer';
    }
}
export function accountPermissionsForRole(role) {
    return {
        get 'account/view'() {
            return this['account/edit'];
        },
        get 'account/edit'() {
            return [Role.Admin].includes(role);
        },
        get 'account/billing/view'() {
            return this['account/billing/edit'];
        },
        get 'account/billing/edit'() {
            return [Role.Admin].includes(role);
        },
        get 'account/team_members/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'account/team_members/edit'() {
            return [Role.Admin].includes(role);
        },
        get 'account/workspaces/create'() {
            return [Role.Admin].includes(role);
        },
        get 'account/api_credentials/view'() {
            return this['account/api_credentials/edit'];
        },
        get 'account/api_credentials/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'account/support_access/view'() {
            return this['account/support_access/edit'];
        },
        get 'account/support_access/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'account/cookie_settings/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'account/cookie_settings/edit'() {
            return [Role.Admin].includes(role);
        },
        get 'account/pipelines/enable'() {
            return [Role.Admin].includes(role);
        },
        get 'account/journeys/enable'() {
            return [Role.Admin].includes(role);
        },
    };
}
export function workspacePermissionsForRole(role) {
    return {
        get 'journeys/workspace_settings/view'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/workspace_settings/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/imports/view'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/imports/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/imports/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/imports/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/exports/view'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/exports/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/exports/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/exports/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/message_settings/view'() {
            return this['journeys/message_settings/edit'];
        },
        get 'journeys/message_settings/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/sending_options/view'() {
            return this['journeys/sending_options/edit'];
        },
        get 'journeys/sending_options/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/campaigns/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/campaigns/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/campaigns/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/campaigns/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/broadcasts/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/broadcasts/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/broadcasts/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/broadcasts/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/newsletters/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/newsletters/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/newsletters/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/newsletters/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/transactional_messages/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/transactional_messages/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/transactional_messages/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/transactional_messages/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/in_app_broadcasts/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/in_app_broadcasts/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/in_app_broadcasts/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/in_app_broadcasts/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/people/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/people/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/people/edit'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/people/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/object_types/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/object_types/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/object_types/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/object_types/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/objects/create'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/objects/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/objects/edit'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/objects/delete'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/object_relationships/create'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/object_relationships/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/object_relationships/edit'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/object_relationships/delete'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/forms/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/forms/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/forms/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/forms/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/sql_syncs/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/sql_syncs/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/sql_syncs/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/sql_syncs/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/js_snippets/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/js_snippets/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/js_snippets/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/js_snippets/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/segment_integration/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/segment_integration/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/segment_integration/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/segment_integration/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/mParticle/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/mParticle/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/reporting_webhooks/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/reporting_webhooks/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/audiences_integration/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/audiences_integration/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/messages/send'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/logs/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/segments/create'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/segments/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/segments/edit'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/segments/delete'() {
            return [Role.Admin, Role.Manager, Role.Author].includes(role);
        },
        get 'journeys/subscription_center/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/subscription_center/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/subscription_center/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/subscription_center/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/collections/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/collections/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/collections/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/collections/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/snippets/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/snippets/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/snippets/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/snippets/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/layouts/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/layouts/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/layouts/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/layouts/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/email_message_settings/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/email_message_settings/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/email_message_settings/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/email_message_settings/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/slack_message_settings/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/slack_message_settings/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/slack_message_settings/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/slack_message_settings/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/twillio_message_settings/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/twillio_message_settings/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/twillio_message_settings/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/twillio_message_settings/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/push_message_settings/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/push_message_settings/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/push_message_settings/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/push_message_settings/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/in_app_message_settings/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/in_app_message_settings/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/in_app_message_settings/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/in_app_message_settings/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/language_settings/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/language_settings/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/language_settings/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/language_settings/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/assets/create'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/assets/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'journeys/assets/edit'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/assets/delete'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.AuthorRedacted,
                Role.AuthorRedactedSensitive,
                Role.AuthorRedactedAll,
            ].includes(role);
        },
        get 'journeys/merge_options/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'journeys/sensitive_data/view'() {
            return [Role.Admin, Role.Manager, Role.Author, Role.Viewer].includes(role);
        },
        get 'journeys/attribute_data/view'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.Viewer,
                Role.AuthorRedactedSensitive,
                Role.ViewerRedactedSensitive,
            ].includes(role);
        },
        get 'journeys/attribute_metadata/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/sources/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'pipelines/sources/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/sources/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/sources/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/destinations/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'pipelines/destinations/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/destinations/edit'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/destinations/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/suppressions/view'() {
            return ALL_ROLES.includes(role);
        },
        get 'pipelines/suppressions/create'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/suppressions/delete'() {
            return [Role.Admin, Role.Manager].includes(role);
        },
        get 'pipelines/sensitive_data/view'() {
            return [Role.Admin, Role.Manager, Role.Author, Role.Viewer].includes(role);
        },
        get 'pipelines/attribute_data/view'() {
            return [
                Role.Admin,
                Role.Manager,
                Role.Author,
                Role.Viewer,
                Role.AuthorRedactedSensitive,
                Role.ViewerRedactedSensitive,
            ].includes(role);
        },
    };
}
// Eventually this will be an attribute returned by the back end rather than
// a large computed object
export function permissionsForRole(role) {
    /* eslint-disable @typescript-eslint/naming-convention */
    return {
        ...accountPermissionsForRole(role),
        ...workspacePermissionsForRole(role),
    };
}
//# sourceMappingURL=roles.js.map